/**
 * Build lab report verification URL for certified diamonds.
 * Strips non-digit characters from certificate ID for the URL.
 * Supports IGI and GIA.
 */

const IGI_BASE = 'https://www.igi.org/verify-your-report/?r=';
const GIA_BASE = 'https://www.gia.edu/report-check?locale=en_US&reportno=';

/**
 * Strip all non-digit characters from certificate ID for URL use.
 * @param {string} certId - Certificate number (e.g. "IGI 12345678" or "1234567890")
 * @returns {string} Digits only
 */
export function certificateIdForUrl(certId) {
  if (certId == null || typeof certId !== 'string') return '';
  return certId.replace(/\D/g, '');
}

/**
 * Get the report verification URL for a certified diamond, or null if not supported.
 * @param {string} certificateNumber - Full certificate number
 * @param {string} [lab] - Lab name (e.g. "IGI", "GIA")
 * @returns {string|null} URL or null
 */
export function getCertificateReportUrl(certificateNumber, lab) {
  const idForUrl = certificateIdForUrl(certificateNumber);
  if (!idForUrl) return null;

  const labNorm = (lab || '').toUpperCase().trim();
  if (labNorm === 'IGI') return `${IGI_BASE}${idForUrl}`;
  if (labNorm === 'GIA') return `${GIA_BASE}${idForUrl}`;
  return null;
}
